'use client';

import { useEffect } from 'react';

export default function FontLoader() {
  useEffect(() => {

    let prefix = '';
    if (
      process.env.NODE_ENV === 'production' &&
      process.env.NEXT_PUBLIC_STATIC_URL &&
      process.env.NEXT_PUBLIC_BUILD_VERSION
    ) {
      prefix = process.env.NEXT_PUBLIC_STATIC_URL + process.env.NEXT_PUBLIC_BUILD_VERSION;
    }

    const fontUrl = `${prefix}${prefix ? '/public' : ''}/fonts/CambridgeSans-Regular.otf`;
    const font = new FontFace('CambridgeSans', `url('${fontUrl}') format('opentype')`, {
      weight: '400',
      style: 'normal',
    });

    font.load().then((loadedFont) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (document.fonts as any).add(loadedFont);
    }).catch((error) => {
      console.error('Failed to load CambridgeSans font:', error);
    });
  }, []);

  return null;
}
